var _path, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMute = function SvgMute(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 85,
    height: 75,
    viewBox: "0 0 85 75",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 85,
    height: 75,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M85 0H0v74.149h85V0Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#131F20",
    fillOpacity: 0.6,
    d: "M84.962 34.251C84.213 13.346 70.137 1.703 49.421.27 24.423-1.471.968 9.044.038 36.409c-.378 11.047 2.2 23.049 11.368 30.249 8.38 6.587 19.81 7.506 30.11 7.483 25.747-.044 44.467-12.689 43.446-39.897"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.666 28.583 34 33.849h-5.334v7.9H34l6.666 5.266V28.583ZM56.666 33.85l-8 7.899M48.666 33.85l8 7.899"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMute);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHdpZHRoPSI4NSIgaGVpZ2h0PSI3NSIgdmlld0JveD0iMCAwIDg1IDc1Ij4KICA8bWFzayBpZD0iYSIgd2lkdGg9Ijg1IiBoZWlnaHQ9Ijc1IiB4PSIwIiB5PSIwIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiBzdHlsZT0ibWFzay10eXBlOmx1bWluYW5jZSI+CiAgICA8cGF0aCBmaWxsPSIjZmZmIiBkPSJNODUgMEgwdjc0LjE0OWg4NVYwWiIvPgogIDwvbWFzaz4KICA8ZyBtYXNrPSJ1cmwoI2EpIj4KICAgIDxwYXRoIGZpbGw9IiMxMzFGMjAiIGZpbGwtb3BhY2l0eT0iLjYiIGQ9Ik04NC45NjIgMzQuMjUxQzg0LjIxMyAxMy4zNDYgNzAuMTM3IDEuNzAzIDQ5LjQyMS4yNyAyNC40MjMtMS40NzEuOTY4IDkuMDQ0LjAzOCAzNi40MDljLS4zNzggMTEuMDQ3IDIuMiAyMy4wNDkgMTEuMzY4IDMwLjI0OSA4LjM4IDYuNTg3IDE5LjgxIDcuNTA2IDMwLjExIDcuNDgzIDI1Ljc0Ny0uMDQ0IDQ0LjQ2Ny0xMi42ODkgNDMuNDQ2LTM5Ljg5NyIvPgogIDwvZz4KICA8ZyBzdHJva2U9IiNmZmYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIj4KICAgIDxwYXRoIGQ9Ik00MC42NjYgMjguNTgzIDM0IDMzLjg0OWgtNS4zMzR2Ny45SDM0bDYuNjY2IDUuMjY2VjI4LjU4M1pNNTYuNjY2IDMzLjg1bC04IDcuODk5TTQ4LjY2NiAzMy44NWw4IDcuODk5Ii8+CiAgPC9nPgo8L3N2Zz4=";